import React from "react";
import { Button } from "antd";
import { ColumnType } from "antd/lib/table";
import { size } from "lodash";
import { EMPTY } from "constants/common";
import { AiccLessonReviewScript, AiccReviewScript } from "types/model/aiccLearningAssets";
import styles from "../LearningAssets.module.scss";

interface ColumnHandlers {
  onView: (record: AiccLessonReviewScript) => void;
}

const getColumns = ({ onView }: ColumnHandlers): ColumnType<AiccLessonReviewScript>[] => [
  {
    title: "Level",
    dataIndex: "level",
    key: "level",
    width: 200,
    render: (level: number) => level ?? EMPTY,
  },
  {
    title: "Lesson",
    dataIndex: "lesson",
    key: "lesson",
    width: 200,
    render: (lesson: number) => lesson ?? EMPTY,
  },
  {
    title: "Scripts Count",
    dataIndex: "scripts",
    key: "scripts",
    width: 200,
    render: (scripts: AiccReviewScript[]) => size(scripts),
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Button type="link" className={styles.linkButton} onClick={() => onView(record)}>
        View
      </Button>
    ),
  },
];

export default getColumns;
